import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isDeleteAppGroupIdFigmaOauthDisconnectResult = objectOf({
  disconnected: boolean,
});
